import React, { useContext, useEffect, useState } from 'react';
import { Input } from '../../../ui/Inputs';
import { useTranslation } from 'react-i18next';
import { useEditCRMUrlMutation } from '../../../../store/api';

import { CRMInputProps } from './types';
import { AuthContext } from '../../../../context/Auth/AuthContext';
import { Roles } from '../../../../constants';
import styles from './CRMModal.module.scss';
import { LinkIcon } from '../../../ui/Icons';

const CRMInput: React.FC<CRMInputProps> = ({ project_id, url }) => {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const isManager = user?.role === Roles.MANAGER;

  const [editCRMUrl] = useEditCRMUrlMutation();
  const [CRMUrl, setCRMUrl] = useState(url ? url : '');
  const validUrl = CRMUrl.trim().startsWith('http') ? CRMUrl.trim() : `https://${CRMUrl.trim()}`;

  const handleChangeCRMUrl = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCRMUrl(value);
  };

  const handleSaveCRMUrl = () => {
    if (!!CRMUrl.trim() && CRMUrl !== url) editCRMUrl({ ID: project_id, crm_url: CRMUrl });
  };

  useEffect(() => {
    setCRMUrl(url || '');
  }, [url]);

  return (
    <div className={styles.crmInputWrapper}>
      <Input
        name="crm-url"
        value={CRMUrl}
        onChange={handleChangeCRMUrl}
        onBlur={handleSaveCRMUrl}
        placeholder={`${t(isManager ? 'emptyCRMUrl' : 'enterCRMUrl')}`}
        disabled={isManager}
        inputClassName={styles.crmInput}
      />

      {CRMUrl && (
        <a href={validUrl} target="_blank" rel="noopener noreferrer" className={styles.crmLink}>
          <LinkIcon />
        </a>
      )}
    </div>
  );
};

export default CRMInput;
